<template>
  <!-- 1、顶部通栏-->
  <AppTopNav />
  <!-- 2、主题区域-->
  <div class="main">
    <!-- 二级路由-->
    <router-view>
    </router-view>
  </div>
</template>

<script>
import AppTopNav from '@/components/AppTopNav.vue';

export default {
  components: {
    AppTopNav,
  },
};
</script>

<style lang="less">
* {
  padding: 0;
  margin: 0;
  overscroll-behavior: none;
}

.main {
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
